export const PAGE_NOTES = {
  pmcHandover:
    "This will update all the selected product's PMC handover checklist, even if a checklist is already created.",
  executionTimeline:
    "This will update all the selected product's execution timeline, even if a checklist is already created.",
};
